import React, { useState, useEffect, useRef } from "react"
import { _Api } from "../api/_call";
import TableColumnModal from "../common/modules/tableColumn";
import { Tablehead } from "../common/modules/Tablehead";
import { useReportSort } from "./useReportSort";
import { reportpurchasetaxlisthead } from "../common/Tablehead";
import { ReportMenuModal } from "../common/modules/reportMenu";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Pagination } from "../common/Pagination";
import { toFormatPrice, toUnformatPrice } from "../common/helpers/function";
import { useTranslation } from 'react-i18next';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import Select from "react-select"
import "./report.scss";

// column indexes (in reportpurchasetaxlisthead) that keep their natural width when the table is stretched
const SUPPLIER_COLUMN = 4;
const SUPPLIER_WIDTH_FACTOR = 0.8; // Supplier column at 80% of its natural width
const NO_STRETCH_COLUMNS = [SUPPLIER_COLUMN];

const PurchaseTaxreport = () => {
  const { t } = useTranslation();
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const stickyTopRef = useRef(null);
  const tableHeadScrollRef = useRef(null);
  const tableBodyScrollRef = useRef(null);
  const tableHeadTableRef = useRef(null);
  const tableBodyTableRef = useRef(null);
  const tableScrollSyncLock = useRef(false);
  const [limit, setLimit] = useState(100);
  const [filtername, setFiltername] = useState('');
  const [datefilter, setDatefilter] = useState(() => {
    const start = new Date();
    start.setDate(start.getDate() - 30);
    start.setHours(0, 0, 0, 0);
    return [start, new Date()];
  });
  const [datelable, setDatelable] = useState('LastMonth')
  const datePickerRef = useRef(null)

  const changeDates = (lable) => {
    const MainDate = new Date();
    if (lable === 'Today') {
      const todayStart = new Date(); todayStart.setHours(0, 0, 0, 0);
      setDatefilter([todayStart, new Date()]); setDatelable('Today');
    } else if (lable === 'Yesterday') {
      const yesterdayStart = new Date(MainDate.setDate(MainDate.getDate() - 1));
      yesterdayStart.setHours(0, 0, 0, 0);
      const yesterdayEnd = new Date(yesterdayStart); yesterdayEnd.setHours(23, 59, 59, 999);
      setDatefilter([yesterdayStart, yesterdayEnd]); setDatelable('Yesterday');
    } else if (lable === '7days') {
      const sevendays = new Date(MainDate.setDate(MainDate.getDate() - 7));
      sevendays.setHours(0, 0, 0, 0);
      const todayEnd = new Date(); todayEnd.setHours(23, 59, 59, 999);
      setDatefilter([sevendays, todayEnd]); setDatelable('7days');
    } else if (lable === '30days') {
      const days = new Date(MainDate.setDate(MainDate.getDate() - 30));
      days.setHours(0, 0, 0, 0);
      const todayEnd = new Date(); todayEnd.setHours(23, 59, 59, 999);
      setDatefilter([days, todayEnd]); setDatelable('30days');
    } else if (lable === 'ThisMonth') {
      const firstDay = new Date(MainDate.getFullYear(), MainDate.getMonth(), 1);
      firstDay.setHours(0, 0, 0, 0);
      const lastDay = new Date(MainDate.getFullYear(), MainDate.getMonth() + 1, 0);
      lastDay.setHours(23, 59, 59, 999);
      setDatefilter([firstDay, lastDay]); setDatelable('ThisMonth');
    } else if (lable === 'LastMonth') {
      const start = new Date();
      start.setDate(start.getDate() - 30);
      start.setHours(0, 0, 0, 0);
      setDatefilter([start, new Date()]); setDatelable('LastMonth');
    }
  }

  const [newcolumndata, setnewcolumndata] = useState(reportpurchasetaxlisthead);
  const [reportpurchasetaxlist, setReportpurchasetaxlist] = useState();
  const reportSort = useReportSort(reportpurchasetaxlist, [null, (r) => r?.date, (r) => r?.doc_type, (r) => r?.ref, (r) => r?.supplier, (r) => r?.ship_to, (r) => r?.sku_count, (r) => r?.qty, (r) => r?.before_tax, (r) => r?.tax, (r) => r?.shipping, (r) => r?.amount, (r) => r?.remark, (r) => r?.user]);
  const [reportpurchasetaxcounts, setReportpurchasetaxcounts] = useState({});
  const [datalodaer, setDatsLodaer] = useState(false)
  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const [state, setstate] = useState({
    totalPages: 0,
    currentPage: 1,
  });
  const { totalPages, currentPage } = state;
  const filterbyname = (search) => {
    setstate({ ...state, currentPage: 1 });
    Getreportpurchasetax(1, limit, search);
  }
  const getlimit = (nextLimit) => {
    setLimit(nextLimit);
    Getreportpurchasetax(1, nextLimit);
    setstate({ ...state, currentPage: 1 });
  };
  const handlePaginations = (current) => {
    setstate({ ...state, currentPage: current });
    Getreportpurchasetax(current, "");
  };
  useEffect(() => {
    callcolumns();
  }, []);

  const Getreportpurchasetax = async (current, firstlimit, search) => {
    setDatsLodaer(true)
    const tablelimit = firstlimit ? firstlimit : limit;
    const skipNumber = current ? (current - 1) * (Number(tablelimit) || 0) : 0;
    try {
      const postdata = {
        "search": search === "" ? search : (search || filtername || ""),
        "limit": tablelimit,
        "skip": skipNumber,
        "start_date": datefilter ? datefilter[0] : "",
        "end_date": datefilter ? datefilter[1] : ""
      };
      let res = await _Api(postdata, `api/v1/Inventory/report/purchaseTaxReport`);
      if (res.code === 200) {
        const page = current ? Number(current) : 1;
        setReportpurchasetaxlist(res?.data || []);
        setReportpurchasetaxcounts(res?.count || {});
        setstate((prev) => ({
          ...prev,
          totalPages: Math.ceil((Number(res?.total) || 0) / (Number(tablelimit) || 1)) || 0,
          currentPage: page,
        }));
      } else {
        // "data not found" -> nothing in this range; clear the old rows
        setReportpurchasetaxlist([]);
        setReportpurchasetaxcounts({});
        setstate((prev) => ({ ...prev, totalPages: 0, currentPage: 1 }));
      }
      setDatsLodaer(false)
    }
    catch (err) {
      setDatsLodaer(false);
      console.log(err, 'err');
    }
  }
  const callcolumns = async () => {
    try {
      const postdata = {
        name: "tbl_report_purchase_register",
      };
      let columnhead = await _Api(
        postdata,
        `api/v1/Inventory/common/getColumnHeads`
      );
      if (columnhead.code === 200 && columnhead?.data?.data?.length) {
        setnewcolumndata(columnhead?.data?.data);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  useEffect(() => {
    if (datefilter[0] && datefilter[1]) {
      Getreportpurchasetax();
    }
    // eslint-disable-next-line
  }, [datefilter]);

  useEffect(() => {
    const el = stickyTopRef.current;
    if (!el) return undefined;
    const page = el.closest(".purchase-report-page");
    const apply = () => {
      if (!page) return;
      page.style.setProperty(
        "--report-sticky-block-height",
        `${el.offsetHeight}px`,
      );
    };
    apply();
    const observer = new ResizeObserver(apply);
    observer.observe(el);
    window.addEventListener("resize", apply);
    return () => {
      observer.disconnect();
      window.removeEventListener("resize", apply);
    };
  }, []);

  const syncTableScroll = (source) => {
    if (tableScrollSyncLock.current) return;
    const head = tableHeadScrollRef.current;
    const body = tableBodyScrollRef.current;
    if (!head || !body) return;
    tableScrollSyncLock.current = true;
    if (source === "head") {
      body.scrollLeft = head.scrollLeft;
    } else {
      head.scrollLeft = body.scrollLeft;
    }
    requestAnimationFrame(() => {
      tableScrollSyncLock.current = false;
    });
  };

  useEffect(() => {
    let frame = 0;
    const syncTableWidths = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const headTable = tableHeadTableRef.current;
        const bodyTable = tableBodyTableRef.current;
        if (!headTable || !bodyTable) return;

        const headThs = headTable.querySelectorAll("thead th");
        const bodyRow = bodyTable.querySelector("tbody tr");
        const count = headThs.length;
        if (!count) return;

        headTable.style.width = "max-content";
        bodyTable.style.width = "max-content";
        headTable.style.tableLayout = "auto";
        bodyTable.style.tableLayout = "auto";
        headThs.forEach((th) => {
          th.style.width = "";
          th.style.minWidth = "";
          th.style.maxWidth = "";
        });
        bodyTable.querySelectorAll("td, th").forEach((cell) => {
          cell.style.width = "";
          cell.style.minWidth = "";
          cell.style.maxWidth = "";
        });

        const widths = [];
        for (let i = 0; i < count; i += 1) {
          const hw = headThs[i].getBoundingClientRect().width;
          const bw = bodyRow?.children[i]?.getBoundingClientRect().width || 0;
          widths.push(Math.ceil(Math.max(hw, bw, 40)));
        }
        // narrow the Supplier column; the name ellipsizes and the tooltip shows it in full
        widths[SUPPLIER_COLUMN] = Math.max(80, Math.floor(widths[SUPPLIER_COLUMN] * SUPPLIER_WIDTH_FACTOR));
        let total = widths.reduce((sum, w) => sum + w, 0);
        const containerWidth = Math.floor(
          tableBodyScrollRef.current?.clientWidth ||
            tableHeadScrollRef.current?.clientWidth ||
            0,
        );
        if (containerWidth > total && total > 0) {
          // Supplier is already capped by its ellipsis, so stretching it only adds empty space;
          // keep it at its natural width and spread the extra over the other columns.
          const fixedWidth = NO_STRETCH_COLUMNS.reduce((sum, i) => sum + (widths[i] || 0), 0);
          const scale = (containerWidth - fixedWidth) / (total - fixedWidth || 1);
          let used = 0;
          for (let i = 0; i < count; i += 1) {
            if (i === count - 1) {
              widths[i] = Math.max(widths[i], containerWidth - used);
            } else {
              if (!NO_STRETCH_COLUMNS.includes(i)) {
                widths[i] = Math.max(1, Math.floor(widths[i] * scale));
              }
              used += widths[i];
            }
          }
          total = containerWidth;
        }
        headTable.style.tableLayout = "fixed";
        bodyTable.style.tableLayout = "fixed";
        headTable.style.width = `${total}px`;
        bodyTable.style.width = `${total}px`;

        for (let i = 0; i < count; i += 1) {
          const widthPx = `${widths[i]}px`;
          headThs[i].style.width = widthPx;
          headThs[i].style.minWidth = widthPx;
          headThs[i].style.maxWidth = widthPx;
          bodyTable
            .querySelectorAll(`tr > :nth-child(${i + 1})`)
            .forEach((cell) => {
              cell.style.width = widthPx;
              cell.style.minWidth = widthPx;
              cell.style.maxWidth = widthPx;
            });
        }

        (newcolumndata || []).forEach((col, index) => {
          const hide = col?.status === false;
          headThs[index]?.classList.toggle("d-none", hide);
          bodyTable
            .querySelectorAll(`tr > :nth-child(${index + 1})`)
            .forEach((cell) => {
              cell.classList.toggle("d-none", hide);
            });
        });
      });
    };

    syncTableWidths();
    window.addEventListener("resize", syncTableWidths);
    const observer = new ResizeObserver(syncTableWidths);
    if (tableHeadScrollRef.current) observer.observe(tableHeadScrollRef.current);
    if (tableBodyScrollRef.current) observer.observe(tableBodyScrollRef.current);

    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener("resize", syncTableWidths);
      observer.disconnect();
    };
  }, [reportpurchasetaxlist, newcolumndata, datalodaer]);

  const sumPrice = (key) => toFormatPrice(
    (reportpurchasetaxlist || []).reduce((sum, row) => sum + toUnformatPrice(row?.[key]), 0),
    { addSymbol: true }
  );
  const sumQty = (reportpurchasetaxlist || []).reduce((sum, row) => sum + (Number(row?.qty) || 0), 0);

  const downloadexclsheet = () => {
    const header_values = reportpurchasetaxlisthead.map((r) => r?.lable);
    const bodyarray = (reportpurchasetaxlist || []).map((result, key) => [
      (currentPage - 1) * (Number(limit) || 0) + key + 1,
      result?.date,
      result?.doc_type,
      result?.ref,
      result?.supplier,
      result?.ship_to,
      result?.sku_count,
      result?.qty,
      result?.before_tax || 0,
      result?.tax || 0,
      result?.shipping || 0,
      result?.amount || 0,
      result?.remark,
      result?.user,
    ]);

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet([
      ["Inventory Report"],
      ["Purchase Register"],
      header_values,
      ...bodyarray,
    ]);
    XLSX.utils.book_append_sheet(wb, ws, 'Records');
    const fileContent = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([fileContent], { type: fileType });
    FileSaver.saveAs(data, "report_purchase_register");
  }
  const selectOptions = [
    { label: 100, value: 100 },
    { label: 200, value: 200 },
    { label: 300, value: 300 }
  ]
  const summaryCards = [
    { label: "Total Qty", value: reportpurchasetaxcounts?.qty || 0, icon: "free-stock.png", className: "stock" },
    { label: "Before Tax", value: reportpurchasetaxcounts?.before_tax || 0, icon: "value.png", className: "value" },
    { label: "Tax", value: reportpurchasetaxcounts?.tax || 0, icon: "value.png", className: "sku" },
    { label: "Total Amount", value: reportpurchasetaxcounts?.amount || 0, icon: "value.png", className: "location" },
  ];
  return (
    <React.Fragment>
      <div className="main-body report-page purchase-report-page product-tab-page-padding-top">
        <div className="container">
          <div className="row">
            <div className="col-lg-12" style={{ display: "flex", flexWrap: "wrap" }}>
              <div className="sticky-top-report-page" ref={stickyTopRef}>
              <h2 className="main-body-heading"><span>{t("report")} {">"}</span>&nbsp;&nbsp;{t("Purchase Register")}</h2>
              <div className="main-body-top-inventory">
                <div className="main-body-top-inventory-status">
                  {summaryCards.map((card) => (
                    <div className="main-body-top-inventory-status-card" key={card.label}>
                      <div className="left-side">
                        <img
                          src={base_assets + "images/icons/" + card.icon}
                          className="inventory-img"
                          alt=""
                        />
                      </div>
                      <div className="right-side">
                        <span className="inventory-name">{t(card.label)}</span>
                        <h2 className={`inventory-value ${card.className}`}>{card.value}</h2>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="main-body-top-status-bar">
                <ReportMenuModal />
                <Select
                  className="limit-select short mx-3 z-10"
                  options={selectOptions}
                  value={{ label: limit, value: limit }}
                  onChange={(e) => {
                    setLimit(e.value);
                    getlimit(e.value);
                  }}
                />
                <div className="main-body-top-status-bar-filter">
                  <input
                    value={filtername}
                    type="text"
                    className="main-body-top-status-bar-filter-input"
                    placeholder={t("Search by Ref")}
                    onKeyDown={(e) => e.key === 'Enter' && filterbyname(e.target.value)}
                    onChange={(e) => setFiltername(e.target.value)}
                  />
                  {filtername ? <img className="main-body-top-status-bar-filter-clear" src={base_assets + 'images/icons/False.png'} onClick={() => { setFiltername(""); filterbyname("") }} alt="" /> : ""}
                  <button onClick={() => filterbyname(filtername)} className="main-body-top-status-bar-filter-search">
                    <i className="fa fa-search" aria-hidden="true" />
                  </button>
                </div>
                <div className="main-body-top-status-bar-multi-date-picker">
                  <div className="main-body-top-status-bar-note-button common-dropdown replenish-date">
                    <button className="dropdown-toggle btn-style align-items-center d-flex" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 4.66667V8L10.5 10.5M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8Z" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      {t(datelable)}
                    </button>
                    <ul className="dropdown-menu dropdown-menu-right-fix" aria-labelledby="dropdownMenuButton1">
                      <li className={`dropdown-item ${datelable === 'Today' ? "active" : ""}`} onClick={() => changeDates('Today')}>{t("Today")}</li>
                      <li className={`dropdown-item ${datelable === 'Yesterday' ? "active" : ""}`} onClick={() => changeDates('Yesterday')}>{t("Yesterday")}</li>
                      <li className={`dropdown-item ${datelable === '7days' ? "active" : ""}`} onClick={() => changeDates('7days')}>{t("Last 7 days")}</li>
                      <li className={`dropdown-item ${datelable === '30days' ? "active" : ""}`} onClick={() => changeDates('30days')}>{t("Last 30 days")}</li>
                      <li className={`dropdown-item ${datelable === 'ThisMonth' ? "active" : ""}`} onClick={() => changeDates('ThisMonth')}>{t("This Month")}</li>
                      <li className={`dropdown-item ${datelable === 'LastMonth' ? "active" : ""}`} onClick={() => changeDates('LastMonth')}>{t("Last Month")}</li>
                      <li className={`dropdown-item ${datelable === 'Custom Range' ? "active" : ""}`} onClick={() => datePickerRef.current.setOpen(true)}>{t("Custom Range")}</li>
                    </ul>
                    <DatePicker
                      selectsRange={true}
                      monthsShown={2}
                      startDate={datefilter[0]}
                      endDate={datefilter[1]}
                      onChange={(update) => {
                        const startDate = update[0];
                        const endDate = update[1];
                        setDatelable("Custom Range");
                        if (startDate && endDate) {
                          const modifiedStartDate = new Date(startDate);
                          modifiedStartDate.setHours(0, 0, 0, 0);
                          const modifiedEndDate = new Date(endDate);
                          modifiedEndDate.setHours(23, 59, 59, 999);
                          setDatefilter([modifiedStartDate, modifiedEndDate]);
                        } else {
                          setDatefilter([startDate, endDate]);
                        }
                      }}
                      dateFormat="yyyy-MM-dd"
                      ref={datePickerRef}
                      autoComplete='none'
                    />
                  </div>
                  <div className="main-body-top-status-bar-print-export-dropdown dropdown">
                    <button
                      className="btn dropdown-toggle"
                      type="button"
                      id="dropdownMenuButton1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <img
                        src={base_assets + "images/icons/ellipsis-circular.png"}
                        alt=""
                      />
                    </button>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuButton1"
                    >
                      <li className="dropdown-item" onClick={downloadexclsheet}>
                        <div className="dropdown-item-img">
                          <img
                            src={base_assets + "images/icons/export-x-icon.png"}
                            alt=""
                          />
                        </div>
                        <span>{t("export")}</span>
                      </li>
                      <li
                        className="dropdown-item"
                        data-bs-toggle="modal"
                        data-bs-target="#columnModal"
                      >
                        <div className="dropdown-item-img">
                          <img
                            src={base_assets + "images/icons/column-icon.png"}
                            alt=""
                          />
                        </div>
                        <span>{t("column")}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              </div>
              <div
                className="main-body-main-table-wrap position-relative report-sticky-table-wrap"
                style={{
                  maxWidth: "100%",
                  width: "100%",
                  overflow: "visible",
                }}
              >
                <div className="report-sticky-thead">
                  <div
                    className="report-table-hscroll report-table-hscroll--head"
                    ref={tableHeadScrollRef}
                    onScroll={() => syncTableScroll("head")}
                  >
                    <table
                      ref={tableHeadTableRef}
                      className="stripe row-border order-column common-table table-striped main-table report-head-table"
                    >
                      <Tablehead
                        tablehead={newcolumndata}
                        tblName={"tbl_report_purchase_register"}
                        setfilterby={""}
                        onSort={reportSort.handleSort}
                        sortConfig={reportSort.sortConfig}
                      />
                    </table>
                  </div>
                </div>
                <div
                    className="report-table-hscroll report-table-hscroll--body"
                    ref={tableBodyScrollRef}
                    onScroll={() => syncTableScroll("body")}
                  >
                  <table
                    id="report_purchase_register"
                    ref={tableBodyTableRef}
                    className="stripe row-border order-column common-table table-striped main-table w-100"
                  >
                    <tbody>
                      {reportpurchasetaxlist ? reportSort.sortedList.map((result, key) => (
                        <tr key={result?.id || key}>
                          <td className="fixed-side">{(currentPage - 1) * (Number(limit) || 0) + key + 1}</td>
                          <td className="fixed-side">{result?.date || ''}</td>
                          <td className="fixed-side">{result?.doc_type || ''}</td>
                          <td className="fixed-side link-color">{result?.ref || ''}</td>
                          <td className="fixed-side"><div className="tooltip-area-up"><div className="truncate-text-subtable">{result?.supplier || ''}</div>{result?.supplier && <span className="tooltip-area-up-text text-white">{result?.supplier}</span>}</div></td>
                          <td className="fixed-side">{result?.ship_to || ''}</td>
                          <td className="fixed-side">{result?.sku_count ?? ''}</td>
                          <td className="fixed-side">{result?.qty ?? ''}</td>
                          <td className="fixed-side">{result?.before_tax || 0}</td>
                          <td className="fixed-side">{result?.tax || 0}</td>
                          <td className="fixed-side">{result?.shipping || 0}</td>
                          <td className="fixed-side">{result?.amount || 0}</td>
                          <td className="fixed-side"><div className="tooltip-area-up"><div className="truncate-text-subtable">{result?.remark || ''}</div>{result?.remark && <span className="tooltip-area-up-text text-white">{result?.remark}</span>}</div></td>
                          <td className="fixed-side">{result?.user || ''}</td>
                        </tr>
                      )) : ''}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td />
                        <td />
                        <td />
                        <td />
                        <td />
                        <td />
                        <td />
                        <td>{sumQty}</td>
                        <td>{sumPrice("before_tax")}</td>
                        <td>{sumPrice("tax")}</td>
                        <td>{sumPrice("shipping")}</td>
                        <td>{sumPrice("amount")}</td>
                        <td />
                        <td />
                      </tr>
                    </tfoot>
                  </table>
                  </div>
                  <div id="table_loader" className={datalodaer ? "mt-4" : "d-none"}>
                    <div className="dots">
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
              </div>
              {reportpurchasetaxlist?.length > 0 ? (
                <Pagination
                  total={totalPages}
                  current={currentPage}
                  pagination={(crPage) => handlePaginations(crPage)}
                />
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
      <TableColumnModal tablehead={reportpurchasetaxlisthead} tblName={"tbl_report_purchase_register"} setnewcolumndata={setnewcolumndata}
        calldatatable={Getreportpurchasetax}></TableColumnModal>
    </React.Fragment>
  );
};
export default PurchaseTaxreport;
